(function () {
  var DURATION = 1800;

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function formatValue(raw, suffix) {
    return raw.toLocaleString('en-US') + suffix;
  }

  function animateStat(el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      el.textContent = formatValue(target, suffix);
      return;
    }

    var start = null;

    function tick(timestamp) {
      if (start === null) start = timestamp;
      var elapsed = timestamp - start;
      var progress = Math.min(elapsed / DURATION, 1);
      var eased = easeOutQuad(progress);
      var current = Math.round(target * eased);

      el.textContent = formatValue(current, suffix);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      }
    }

    window.requestAnimationFrame(tick);
  }

  var sections = document.querySelectorAll('.section-tg-stats-counter');

  sections.forEach(function (section) {
    var stats = section.querySelectorAll('[data-tg-stat-value]');
    if (!stats.length) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stats.forEach(animateStat);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(section);
  });
})();
